import { createStore, compose, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';

import reducers from '../app/reducers';

import { productsMiddlewareFactory } from './ProductsMiddleware';
import { faqMiddleware } from './FaqMiddleware';

// TODO: MB-4614 upgrade window.devToolsExtension, see point 1.3 here:
// https://github.com/zalmoxisus/redux-devtools-extension
export const storeFactory = (apiUrl) => {
  const productionMiddleware = [
    thunkMiddleware.withExtraArgument(apiUrl),
    productsMiddlewareFactory(apiUrl),
    faqMiddleware,
  ];

  const developmentMiddleware = [...productionMiddleware];
  const middleware = PRODUCTION ? productionMiddleware : developmentMiddleware;
  const hasDevTools = typeof window === 'object' && typeof window.devToolsExtension !== 'undefined';

  const store = createStore(
    reducers,
    compose(applyMiddleware(...middleware), hasDevTools ? window.devToolsExtension() : (f) => f),
  );

  return store;
};
